import React from 'react';
import { Lightbulb, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const statusLabel = (s) => { const t = (s || '').replace(/_/g, ' ').toLowerCase(); return t.charAt(0).toUpperCase() + t.slice(1); };

/** Under a CLUBBED request: which request it rides with and that request's status. */
export const ClubbedInto = ({ r, testId }) => (r.status === 'CLUBBED' && r.clubbed_into_route ? (
  <div className="text-[11px] text-violet-700 mt-1" data-testid={testId}>
    With {r.clubbed_into_section ? `${r.clubbed_into_section}: ` : ''}{r.clubbed_into_route} · {statusLabel(r.clubbed_into_status)}
  </div>
) : null);

/** On the main request: the requests clubbed into it (✕ unclubs one when `onUnclub` is given). */
export const ClubbedFrom = ({ r, testId, onUnclub }) => ((r.clubbed_from || []).length > 0 ? (
  <div className="mt-1.5 flex flex-wrap gap-1" data-testid={testId}>
    {r.clubbed_from.map((c) => (
      <span key={c.id} className="inline-flex items-center gap-1 text-[11px] bg-violet-50 text-violet-700 border border-violet-200 rounded-full pl-2 pr-1 py-0.5" data-testid={`${testId}-${c.id}`}>
        + {c.section || '—'}: {c.route}
        {onUnclub && (
          <button type="button" onClick={() => onUnclub(c)} title="Unclub — send this request back to Pending" className="rounded-full p-0.5 hover:bg-violet-200 transition-colors" data-testid={`unclub-btn-${c.id}`}>
            <X className="w-3 h-3" />
          </button>
        )}
      </span>
    ))}
  </div>
) : null);

/** Dispatch Board hint: other PENDING requests going the same way, with one-tap clubbing. */
export const ClubHint = ({ r, peers, onClub }) => (peers.length > 0 ? (
  <div className="mt-2 rounded-md bg-violet-50/70 border border-violet-200 px-2 py-1.5 flex items-start justify-between gap-2" data-testid={`dispatch-club-hint-${r.id}`}>
    <div className="text-[11px] text-violet-800 min-w-0">
      <p className="font-semibold flex items-center gap-1"><Lightbulb className="w-3 h-3" />Can be clubbed</p>
      {peers.slice(0, 3).map((p) => (
        <p key={p.id} className="truncate" data-testid={`dispatch-club-hint-${r.id}-${p.id}`}>{p.section || '—'}: {p.route} <span className="text-violet-500">· {p.reason}</span></p>
      ))}
      {peers.length > 3 && <p className="text-violet-500">+{peers.length - 3} more</p>}
    </div>
    <Button size="sm" className="h-6 px-2 text-[11px] bg-violet-600 hover:bg-violet-700 shrink-0" onClick={() => onClub([r.id, ...peers.map((p) => p.id)])} data-testid={`dispatch-club-these-${r.id}`}>Club these</Button>
  </div>
) : null);
